import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService, UnitItem } from '../../../services/logistic.service';
import { TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-operation',
  templateUrl: './operation.component.html',
  styleUrls: ['./operation.component.css']
})
export class OperationComponent implements OnInit {
    public operationId: string;

    public edit?: Edit;

    public selectListUnits: UnitItem[] = [];

    public saving = false;

    public prodIdButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        this.operationId = this.stateService.getStateParams()['operation_id'];
    }

    private async loadEdit() {
        if (!!this.operationId) {
            this.edit = (await this.datatask.Post(266, { operation_id: this.operationId }))[0];
        }
    }

    private async loadUnits() {
        this.selectListUnits = await this.logistic.getUnitList({ onlytimeunits: '1' });
    }

    public searchProductNames = () => {
        return this.typeahead.lookUpProducts({ prod_name: this.edit?.prod_name || '' });
    }

    public async onProductNameSelected(item?: Item) {
        if (!!this.edit) {
            this.edit.prod_id = item?.item_id ?? '';
            this.edit.prod_name = item?.item_name ?? '';
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(381, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadUnits();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    operation_id: number;
    operation_name: string;
    direct: number;
    unit_no: number;
    cost_pr_unit: string;
    note: string;
    active: number;
    prod_id: string | number;
    prod_name: string;
    isnew: number;
    prod_keyno: string;
    adjustment_unit_no: number;
    adjustment_unit_name: string;
    postcalculation_from_powtime: number;
    unit_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operation', {
//        templateUrl: 'views/components/views/operation/operation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'operationService', 'logisticService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, operationService, logisticService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationId = $stateParams.operation_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                operationId: operationId,
//                prodIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno }) }
//                ],
//                edit: {},
//                selectListUnits: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await operationService.getOperation({ operation_id: operationId }))[0];
//            }

//            async function loadUnits() {
//                vm.model.selectListUnits = await logisticService.listUnits({ onlytimeunits: '1' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.searchProduct({ prod_name: vm.model.edit[id] || '' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'prod_name':
//                        if (item) {
//                            vm.model.edit.prod_id = item?.item_id ?? '';
//                            vm.model.edit.prod_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('prod_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit.prod_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.prod_id = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('prod_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'prod_name':
//                        vm.model.edit.prod_id = '';
//                        vm.model.edit.prod_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                operationService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ANGULAR LIFE CYCLE FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadUnits();
//            };

//            // #endregion ANGULAR LIFE CYCLE FUNCTION

//        }]
//    });
//})();
